export type RefetchKanbanColumnArg =
  | number
  | { statusId: number; silent?: boolean }

export const parseRefetchKanbanColumnArg = (
  arg: RefetchKanbanColumnArg,
): { statusId: number; silent: boolean } => {
  if (typeof arg === 'number') {
    return { statusId: arg, silent: false }
  }
  return { statusId: arg.statusId, silent: Boolean(arg.silent) }
}
